import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// English locale files
import commonEn from './locales/en/common.json'
import entranceEn from './locales/en/entrance.json'
import shopsEn from './locales/en/shops.json'
import scanEn from './locales/en/scan.json'
import deliveryEn from './locales/en/delivery.json'
import viewerEn from './locales/en/viewer.json'
import errorsEn from './locales/en/errors.json'

// Arabic locale files
import commonAr from './locales/ar/common.json'
import entranceAr from './locales/ar/entrance.json'
import shopsAr from './locales/ar/shops.json'
import scanAr from './locales/ar/scan.json'
import deliveryAr from './locales/ar/delivery.json'
import viewerAr from './locales/ar/viewer.json'
import errorsAr from './locales/ar/errors.json'

const resources = {
  en: {
    common: commonEn,
    entrance: entranceEn,
    shops: shopsEn,
    scan: scanEn,
    delivery: deliveryEn,
    viewer: viewerEn,
    errors: errorsEn,
  },
  ar: {
    common: commonAr,
    entrance: entranceAr,
    shops: shopsAr,
    scan: scanAr,
    delivery: deliveryAr,
    viewer: viewerAr,
    errors: errorsAr,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'entrance', 'shops', 'scan', 'delivery', 'viewer', 'errors'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'dukkan-lang',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  })

export default i18n
